import { MapPin } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { WA_LINK, ZONES } from "@/lib/site";

export const Coverage = () => (
  <section id="cobertura" data-testid="coverage-section" className="border-y border-white/10 bg-[#0A0A0A]">
    <div className="mx-auto grid max-w-7xl gap-12 px-6 py-24 md:grid-cols-2 md:py-32">
      <div>
        <Reveal>
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-krono">[ Cobertura ]</p>
          <h2 className="font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
            Pintura predial em altura em toda São Paulo.
          </h2>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-white/60">
            Atendemos condomínios e residências na capital e região metropolitana. Não achou sua região? Chama no WhatsApp.
          </p>
        </Reveal>
        <div className="mt-10 border-t border-white/10">
          {ZONES.map((z, i) => (
            <Reveal key={z} delay={i * 0.04}>
              <div
                data-testid={`coverage-zone-${i + 1}`}
                className="group flex items-center gap-4 border-b border-white/10 py-4 transition-colors hover:bg-white/5"
              >
                <MapPin className="h-4 w-4 text-krono" />
                <span className="font-mono text-sm uppercase tracking-[0.15em] text-white/80 transition-colors group-hover:text-krono">
                  {z}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
      <Reveal delay={0.15} className="relative hidden min-h-[420px] overflow-hidden border border-white/10 md:block">
        <img
          src="https://images.pexels.com/photos/11335276/pexels-photo-11335276.jpeg?auto=compress&cs=tinysrgb&w=1200"
          alt="Skyline de São Paulo ao entardecer"
          className="absolute inset-0 h-full w-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
        <a
          href={WA_LINK}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="coverage-cta-whatsapp"
          className="absolute bottom-6 left-6 bg-krono px-6 py-3 font-mono text-xs font-bold uppercase tracking-[0.15em] text-black transition-colors hover:bg-krono-hover"
        >
          Verificar minha região
        </a>
      </Reveal>
    </div>
  </section>
);
